import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  //   CFormSelect,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import React, { useEffect, useRef, useState } from "react";
// import ReactPaginate from "react-js-pagination";
import { useSelector, useDispatch } from "react-redux";
import { useReactToPrint } from "react-to-print";
import { getAllProductReportBasedOnLoan } from "src/api/allApis";

const ProductDetails = () => {
  const dispatch = useDispatch();

  const { productloanReports } = useSelector(
    (state) => state?.interestsReducer
  );
  // const [currentPage, setCurrentPage] = useState(1);
  const [showEmiDetails, setShowEmiDetails] = useState(true);
  const componentPDF = useRef();
  const [printState, setPrintState] = useState(false);

  const SchemaName = sessionStorage.getItem("schemaName");

  useEffect(() => {
    const obj = { schemaName: SchemaName };
    getAllProductReportBasedOnLoan(obj);
  }, []);

  useEffect(() => {
    if (printState) {
      generatePDF();
    }
  }, [printState]);

  const download_btn = () => {
    setPrintState(true);
  };

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "userData",
    onAfterPrint: () => setPrintState(false),
  });

  const { totalApprovedAmount, totalRequestedAmount } = (
    productloanReports || []
  ).reduce(
    (acc, loan) => {
      acc.totalApprovedAmount += parseFloat(loan.totalApprovedAmount || 0);
      acc.totalRequestedAmount += parseFloat(loan.totalRequestedAmount || 0);
      return acc;
    },
    { totalApprovedAmount: 0, totalRequestedAmount: 0 }
  );

  return (
    <div className="content">
      <CCard>
        <CCardHeader>
          <div className="flex justify-between">
            <strong>Products Details</strong>
            <div>
              <div>
                <CButton
                  className="add-btn mr-10 w-auto"
                  onClick={download_btn}
                >
                  Download
                </CButton>
              </div>

              {showEmiDetails === false ? (
                <CButton
                  className="add-btn m-0 w-auto"
                  onClick={() => setShowEmiDetails(true)}
                >
                  Back
                </CButton>
              ) : (
                ""
              )}
            </div>
          </div>
        </CCardHeader>
        <CCardBody>
          <div>
            <CRow
              style={{
                width: "-webkit-fill-available !important",
                alignItems: "end",
                justifyContent: "end",
              }}
            >
              <CCol xs={3}></CCol>

              <CCol xs={3}>
                {/* <CButton onClick={handleSearch}>Search</CButton> */}
              </CCol>
            </CRow>
          </div>
          <div className="serch_bar"></div>
          <div
            style={{
              marginTop: "30px",
              display: "flex",
              flexDirection: "row",
              gap: "20px",
              fontWeight: "600",
              fontSize: "16px",
            }}
          >
            <strong>
              Total Approved Amount:
              <span style={{ color: "blue" }}>{totalApprovedAmount}</span>{" "}
            </strong>
            {""}
            <strong>
              Total Requested Amount:
              <span style={{ color: "blue" }}>{totalRequestedAmount}</span>
            </strong>
          </div>
          <div
            ref={printState ? componentPDF : null}
            style={{ padding: printState ? "20px" : "0px" }}
          >
            <div style={{ marginTop: "40px" }}>
              <CTable hover className="" responsive>
                <CTableHead>
                  <CTableRow>
                    <CTableHeaderCell scope="col" className="">
                      <span className="">Sr No.</span>
                    </CTableHeaderCell>
                    <CTableHeaderCell scope="col" className="">
                      <span className="">loanType</span>
                    </CTableHeaderCell>
                    <CTableHeaderCell scope="col" className="">
                      <span className="">Total Approved Amount</span>
                    </CTableHeaderCell>
                    <CTableHeaderCell scope="col" className="">
                      <span className="">Total Requested Amount </span>
                    </CTableHeaderCell>
                    <CTableHeaderCell scope="col" className="">
                      <span className="">Status</span>
                    </CTableHeaderCell>
                  </CTableRow>
                </CTableHead>
                <CTableBody>
                  {productloanReports?.length > 0 &&
                    productloanReports?.map((company, index) => {
                      //   const { totalPendingEmi, totalPaidEmi } =
                      //     calculateEmiTotals(company?.loans || []);
                      return (
                        <CTableRow key={index}>
                          <CTableDataCell>{index + 1}</CTableDataCell>
                          <CTableDataCell style={{ cursor: "pointer" }}>
                            {company?.loanType || "-"}
                          </CTableDataCell>
                          <CTableDataCell style={{ cursor: "pointer" }}>
                            {`${company.totalApprovedAmount}` || "-"}
                          </CTableDataCell>

                          <CTableDataCell style={{ cursor: "pointer" }}>
                            {company?.totalRequestedAmount || "-"}
                          </CTableDataCell>
                          <CTableDataCell style={{ cursor: "pointer" }}>
                            {/* {company?.loanStatusCount} */}
                            {Object.keys(company?.loanStatusCount).map(
                              (key, index) => (
                                <CRow key={index}>
                                  <td>
                                    {key} : {company?.loanStatusCount[key]}
                                  </td>
                                </CRow>
                              )
                            )}
                          </CTableDataCell>
                        </CTableRow>
                      );
                    })}
                </CTableBody>
              </CTable>
            </div>
          </div>
        </CCardBody>
      </CCard>
    </div>
  );
};

export default ProductDetails;
